<template>
    <div class="people" :class="{cover: user.cover ? 'cover' : ''} " :style="{backgroundImage: 'url('+ user.cover +')'}">
        <online :last_activity="this.user.last_activity" />
        <div class="people-avatar" :style="{backgroundImage: 'url('+ user.avatar +')', backgroundPosition: user.avatar_position}">
            <div class="people-elems">
                <div class="people-elems__item" :class="{green: canSendOffer}" :title="getTitleFriendship" @click.prevent.stop="sendOffer(user.id)">
                    <img v-if="offer != null ? !offer : !canSendOffer" src="@/assets/images/defaults/icon_handshake.png" />
                    <img v-if="(offer != null ? offer : getHasOffer) && !getFriendship" src="@/assets/images/icons/icon_check.svg" />
                    <img v-if="friend != null ? friend : getFriendship" src="@/assets/images/defaults/icon_friend.png" />
                    <!-- <p>Добавить в друзья</p> -->
                </div>
                <div class="people-elems__item" title="Отправить сообщение" @click.stop="sendMessage()">
                    <img src="@/assets/images/defaults/icon_chat.png" />
                </div>
                <!-- <div class="people-elems__item" @click="logout()" title="Пожаловаться">
                    <img src="@/assets/images/defaults/icon_police.png" />
                </div> -->
            </div>
            <!-- <div class="people-rate" v-if="user.rate" :title="user.rate.title" :class="user.rate.color">
                <img :src="require(`@/assets/images/defaults/icon_${user.rate.image}.png`)">
            </div> -->
        </div>
        <div class="people-wrap">

            <p class="people__name">{{ user.firstname + ' ' + user.lastname }}</p>
            <p class="people__status" :class="{'people__status_without-line': !user.sports || user.sports.length == 0}">{{ user.nickname ? '@' + user.nickname : user.shortdesc }}</p>
            <!-- <p class="people-description">{{ user.city ? user.city.name + ',' : ''}} {{ getSex(user) }}, {{ getExperience(user) || ''}}</p> -->
            <div class="people-category" v-if="user.sports">
                <div 
                @click.prevent.stop="setSport(sport)" 
                v-for="sport in shortSports" 
                :key="sport.id" class="people-category__item"
                :class="sport.color">{{sport.ru ? sport.ru : sport.name }}</div>
                <div class="people-category__item dark" v-if="user.sports.length > 5">и еще {{user.sports.length - 5}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'People',
    props: {
        user: {
            type: Object,
            required: true
        },
        friends: {
            type: Array,
            required: false
        },
        offers: {
            type: Array,
            required: false
        },
        click: {
            type: Function,
            require: false
        }
    },
    components: {
        Online: () => import('./Online')
    },
    computed: {
        getUser () {
            return this.$store.getters.getAuthUser
        },
        shortSports() {
            return this.user.sports.slice(0, 5)
        },
        getAuthUser() {
            return this.$store.getters.getAuthUser
        },
        getFriendship () {
            let frienship = this.friends && this.friends.length > 0 ? this.friends.find(friend => friend == this.user.id) ? true : false : false;
            return frienship
        },
        getHasOffer () {
            return this.offers ? this.offers.find(offer => offer == this.user.id) ? true : false : false
        },
        canSendOffer() {
            return this.getAuthUser.friend != null ? this.friend : this.getFriendship ? this.getFriendship : this.getHasOffer
        },
        getTitleFriendship () {
            return this.getHasOffer ? 'Заявка отправлена' : this.getFriendship ? 'Удалить из друзей'  :  'Добавить в друзья'
        }
    },
    data: () => {
        return {
            friend: null,
            offer: null
        }
    },
    methods: {
        setSport(cat) {
            cat.active = true;
            this.$store.dispatch("changeSports", cat);
        },
        getSex(user) {
            return user.sex ? 'Мужчина' : 'Женщина'
        },
        getExperience(user) {
            return user.experience ? 'катается ' + user.experience : 'еще не катался'
        },
        async sendOffer(user) {
            if (this.getFriendship) {
                this.friend = await !this.$store.dispatch('deleteFriend', {user: this.getAuthUser.id, friend: this.user.id})
                !this.friend ? this.$emit('deleteFriend', user.id) : ''
            } else if (this.getHasOffer) {
                this.offer = false
                this.offer = await !this.$store.dispatch('cancelOffer', {from: this.getAuthUser.id, to: this.user.id})
            } else {
                this.offer = true
                this.offer = await this.$store.dispatch('sendOffer', {from: this.getAuthUser.id, to: user})
                this.$store.dispatch('createNotification', {from_id: this.getAuthUser.id, user, type: 'new_friendship'} )
            }
        },
        async sendMessage () {
            let you = this.getUser;
            let user = this.user;
            let data = {
                users: [you.id, user.id],
                locked: true,
                title: 'dialog-'+ you.id + '-' + user.id,
                can_add: false,
                author: {id: you.id},
                type: 'dialog'
            };
            let chat = await this.$store.dispatch('createChat', data);
            this.$router.push({name: 'chat', params: {hash: chat.id + '&' + 'dialog-' + you.id + '-' + user.id}})
        }
    }
}
</script>

<style lang="stylus">
.people
    width 30%
    max-width 315px
    max-width 288px
    width 288px
    border-radius 20px
    background var(--blocks)
    box-shadow var(--blocks-shadow)
    border var(--people-borders)
    padding 25px
    margin 7px
    display flex
    flex-direction column
    align-items center
    position relative
    +to-width(767px)
        margin 7px 0

    &.cover
        background-size cover
        position relative
        overflow hidden
        &:after
            content ''
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            background linear-gradient(0deg, rgba(0,0,0,0.5), transparent)
        .people__name
            color white
        .people-description
            color white
        .people-avatar
            border 4px solid white


    &-avatar
        width 180px
        height 180px
        border-radius 50%
        // background #f0f0f0
        background white
        cursor pointer
        margin-top 15px
        position relative
        z-index 2
        background-size cover
        background-position center
        background-image url('https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif')

        &:hover
            .people-elems
                transform rotate(100deg)
                opacity 1
                pointer-events all
    
    &__name
        font-size 16px
        text-align center
        font-weight 600
        color var(--text-main)
        margin-top 25px
        position relative
        z-index 2
        
    &__status
        font-size 14px
        text-align center
        font-weight 500
        font-style italic
        color #b1b0b0
        margin-top 10px
        position relative
        z-index 2
        padding-bottom 15px
        width 100%
        
    
    &-description
        font-size 12px
        font-weight 500
        line-height 16px
        min-height 32px
        color black
        margin-top 16px
        position relative
        z-index 2

    
    &-category
        display flex
        margin-top 10px
        width calc(100% + 10px)
        margin-left -5px
        margin-right -5px
        position relative
        z-index 2
        // justify-content center
        flex-wrap wrap

        &__item
            margin 3px
            padding 8px 14px
            border-radius 50px
            // background-color #333
            color white
            font-size 12px
            font-weight 500
            text-transform lowercase
            // font-style italic
            cursor pointer
            &.dark
                background var(--main)
            &.gray
                background #aaa
                cursor default
    &-rate
        width 37px
        height 37px
        border-radius 50%
        background-color black
        position absolute
        left 5px
        top 5px
        center()
        border 2px solid white
        img
            max-width 60%
        
        &.green
            background-color $green
        
        &.indianred
            background-color indianred
    
    &-elems
        width 100%
        height 100%
        position absolute
        opacity 0
        pointer-events none
        transition all 0.6s
        +to-width(1023px)
            opacity 1
            pointer-events all
            transform rotate(100deg)
            
        &__item
            max-width 37px
            min-width 37px
            height 37px
            border-radius 50%
            border 2px solid white
            background var(--main)
            position absolute
            padding 6px
            cursor pointer
            left 0
            top 0
            img
                max-width 100%
                transform rotate(-100deg)
            p
                transform rotate(-100deg)
                margin-left 5px
                white-space nowrap
                color white
                font-weight 500

            &:nth-child(2)
                left 35px
                top -17px
            &:nth-child(3)
                left 73px
                top -20px
            
            &.green
                background #8fbc8f
    
    &_pseudo
        .people__name
            background-color #f0f0f0
            width 80%
            height 20px
            border-radius 20px
        .people-avatar
            background-image none
        .people-category__item
            background-color #f0f0f0
            width 80px
            height 20px
</style>